// Copart virtual bid fee (Oct 2026). Live bid is used for estimates.
export const CopartVirtualBidFeeCalculator = (amount, type = 'live-bid') => {
  const pre = type === 'pre-bid';
  if (amount <= 99.99) return 0;
  if (amount <= 499.99) return pre ? 40.00 : 50.00;
  if (amount <= 999.99) return pre ? 55.00 : 65.00;
  if (amount <= 1499.99) return pre ? 75.00 : 85.00;
  if (amount <= 1999.99) return pre ? 85.00 : 95.00;
  if (amount <= 3999.99) return pre ? 100.00 : 110.00;
  if (amount <= 5999.99) return pre ? 110.00 : 125.00;
  if (amount <= 7999.99) return pre ? 125.00 : 145.00;
  return pre ? 140.00 : 160.00;
};
